/**
 * Email validation
 * @param {string} email 
 * @returns {boolean}
 */
export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

/**
 * Phone number validation - only allows digits, spaces, dashes, and parentheses
 * @param {string} phone 
 * @returns {boolean}
 */
export const validatePhone = (phone) => {
  // Remove all non-digit characters for validation
  const digitsOnly = phone.replace(/\D/g, '');
  // Check if we have at least 7 digits and max 15 digits
  return digitsOnly.length >= 7 && digitsOnly.length <= 15;
};

/**
 * Format phone number to digits only
 * @param {string} phone 
 * @returns {string}
 */
export const formatPhoneToDigits = (phone) => {
  return phone.replace(/\D/g, '');
};

/**
 * Validate phone input - only allow digits, spaces, dashes, parentheses
 * @param {string} value 
 * @returns {string}
 */
export const sanitizePhoneInput = (value) => {
  // Only allow digits, spaces, dashes, and parentheses
  return value.replace(/[^\d\s\-()]/g, '');
};

export default {
  validateEmail,
  validatePhone,
  formatPhoneToDigits,
  sanitizePhoneInput
};
